export default __webpack_public_path__ + "static/media/illustration-recruit-2-w@2x.2df6c562.webp";